// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { urlLinksResponseSchema } from '@/url-link/api/types';

export async function getReturnOrderURLLinks(key: string) {
  const path = `/v1/return-order/${key}/url-link`;
  const response = await api.get(path);

  return parseResponse(urlLinksResponseSchema, response.data, {
    schemaName: 'ReturnOrderURLLinks',
    endpoint: path,
  });
}
